/* OrbitaClick · 14-10-2026 · Cocina "compra por tareas". Lee precio y stock en vivo y añade a la cesta lateral del tema. */
(() => {
  const root = document.getElementById('kimia-cocina-shop');
  if (!root) return;
  document.body.classList.add('kimia-cocina-page');
  const config = JSON.parse(root.querySelector('[data-kc-config]').textContent);
  const labels = config.labels, groups = config.groups;
  const cache = new Map();
  const TTL = 10 * 60 * 1000;
  let revision = 0;

  const fmt = new Intl.NumberFormat(config.locale || 'es-ES', { style: 'currency', currency: config.currency || 'EUR' });
  const money = cents => fmt.format(cents / 100);
  const make = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text !== undefined) el.textContent = text; return el; };
  const productUrl = handle => '/products/' + encodeURIComponent(handle);
  const sized = (src, w) => {
    if (!src) return '';
    let url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  };

  function readStore(handle) {
    try {
      const raw = sessionStorage.getItem('kc:' + handle);
      if (!raw) return null;
      const item = JSON.parse(raw);
      return Date.now() - item.t < TTL ? item.p : null;
    } catch (e) { return null; }
  }
  function writeStore(handle, p) {
    try { sessionStorage.setItem('kc:' + handle, JSON.stringify({ t: Date.now(), p })); } catch (e) { /* sin almacenamiento */ }
  }
  function product(handle) {
    if (!cache.has(handle)) {
      const stored = readStore(handle);
      cache.set(handle, stored ? Promise.resolve(stored) : fetch(productUrl(handle) + '.js', { credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw Error('product ' + r.status); return r.json(); })
        .then(p => {
          const slim = { title: p.title, featured_image: p.featured_image, variants: p.variants.map(v => ({ id: v.id, price: v.price, available: v.available, featured_image: v.featured_image ? { src: v.featured_image.src } : null })) };
          writeStore(handle, slim);
          return slim;
        })
        .catch(err => { cache.delete(handle); throw err; }));
    }
    return cache.get(handle);
  }

  async function addToCart(variantId, button, msg, done) {
    msg.hidden = true;
    button.disabled = true;
    button.textContent = labels.adding;
    try {
      const r = await fetch(config.cart_add + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.description || data.message || labels.error);
      button.classList.add('is-added');
      button.textContent = labels.added;
      if (window.ajaxCart && typeof window.ajaxCart.open === 'function') {
        window.ajaxCart.open({ fallbackUrl: config.cart_url });
      } else {
        window.location.assign(config.cart_url);
      }
      setTimeout(() => { button.classList.remove('is-added'); button.disabled = false; done(); }, 2200);
    } catch (e) {
      button.disabled = false;
      done();
      msg.textContent = e && e.message ? e.message : labels.error;
      msg.hidden = false;
    }
  }

  async function card(key, tool) {
    const family = groups[key];
    if (!family) return null;
    const results = await Promise.allSettled(family.options.map(async option => {
      const p = await product(option.handle);
      const variant = p.variants.find(v => v.available) || p.variants[0];
      return variant ? { ...option, product: p, variant } : null;
    }));
    const options = results.filter(r => r.status === 'fulfilled' && r.value).map(r => r.value);
    if (!options.length) return null;

    const article = make('article', 'kc-product');
    const photo = make('a', 'kc-photo');
    const image = make('img');
    image.width = 300; image.height = 300; image.loading = 'lazy'; image.decoding = 'async'; image.alt = '';
    photo.append(image);
    photo.setAttribute('tabindex', '-1');
    photo.setAttribute('aria-hidden', 'true');

    const body = make('div', 'kc-body');
    const h = make('h3');
    const titleLink = make('a', '', family.name);
    h.append(titleLink);
    const form = make('form', 'kc-product-form');
    form.method = 'post';
    form.action = config.cart_add;
    const variantInput = make('input'); variantInput.type = 'hidden'; variantInput.name = 'id';
    const qty = make('input'); qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1';
    // Sin id a propósito: el plugin de selects del tema (BVSelect) transforma los select[id] y los deja en "Select Option".
    const select = make('select', 'kc-format');
    select.setAttribute('aria-label', labels.format + ': ' + family.name);
    const selectLabel = make('span', 'kc-format-label', labels.format);
    selectLabel.setAttribute('aria-hidden', 'true');
    options.forEach((o, i) => {
      const opt = make('option', '', o.label + (o.variant.available ? '' : ' · ' + labels.unavailable));
      opt.value = String(i);
      select.append(opt);
    });
    const price = make('p', 'kc-price');
    price.setAttribute('aria-live', 'polite');
    const button = make('button', 'kc-buy' + (tool ? ' kc-complement' : ''));
    button.type = 'submit';
    const msg = make('p', 'kc-msg'); msg.hidden = true; msg.setAttribute('role', 'alert');
    const link = make('a', 'kc-product-link', labels.details);

    function update() {
      const o = options[Number(select.value)];
      const pic = (o.variant.featured_image && o.variant.featured_image.src) || o.product.featured_image;
      if (pic) { image.src = sized(pic, 400); image.srcset = sized(pic, 240) + ' 240w, ' + sized(pic, 400) + ' 400w, ' + sized(pic, 600) + ' 600w'; image.sizes = '(max-width: 760px) 112px, 280px'; }
      photo.hidden = !pic;
      variantInput.value = String(o.variant.id);
      price.textContent = money(o.variant.price);
      button.disabled = !o.variant.available;
      button.textContent = o.variant.available ? (tool ? labels.add_tool : labels.add) : labels.unavailable;
      const href = productUrl(o.handle) + '?variant=' + o.variant.id;
      link.href = href; titleLink.href = href; photo.href = href;
      link.setAttribute('aria-label', labels.details + ': ' + o.product.title);
    }
    select.addEventListener('change', update);
    form.addEventListener('submit', ev => {
      ev.preventDefault();
      if (button.disabled) return;
      addToCart(Number(variantInput.value), button, msg, update);
    });
    // Todo dentro de un contenedor: el tema asigna z-index a los hijos directos de cualquier <form>.
    const inner = make('div', 'kc-form-inner');
    inner.append(variantInput, qty);
    if (options.length > 1) inner.append(selectLabel, select);
    else if (options[0].label && options[0].label !== family.name) inner.append(make('p', 'kc-single-format', options[0].label));
    inner.append(price, button, msg);
    form.append(inner);
    body.append(h);
    if (family.desc) body.append(make('p', 'kc-product-desc', family.desc));
    body.append(form, link);
    article.append(photo, body);
    update();
    return article;
  }

  const zoneButtons = [...root.querySelectorAll('[data-kc-zone]')];
  const titleEl = root.querySelector('[data-kc-title]');

  async function show(index, fromClick) {
    const current = ++revision, z = config.zones[index];
    zoneButtons.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
    titleEl.textContent = z.name;
    const introEl = root.querySelector('[data-kc-intro]'); introEl.textContent = z.intro; if (z.link && z.link.url) { const more = document.createElement('a'); more.className = 'kc-zone-more'; more.href = z.link.url; more.textContent = z.link.label; introEl.append(' ', more); }
    const main = root.querySelector('[data-kc-products]'), tools = root.querySelector('[data-kc-tools]');
    main.setAttribute('aria-busy', 'true');
    main.replaceChildren(make('p', 'kc-loading', labels.loading));
    tools.replaceChildren();
    const toolsBox = tools.closest('.kc-accessories');
    if (toolsBox) toolsBox.hidden = !z.tools.length;
    if (fromClick) {
      const top = titleEl.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) titleEl.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    const sections = await Promise.all(z.sections.map(async section => {
      const element = make('section', 'kc-product-section');
      element.append(make('h3', 'kc-section-label', section.title));
      const grid = make('div', 'kc-grid');
      const cards = await Promise.all(section.keys.map(k => card(k, false).catch(() => null)));
      cards.filter(Boolean).forEach(c => grid.append(c));
      if (!grid.children.length) grid.append(make('p', '', labels.empty));
      element.append(grid);
      return element;
    }));
    const accessories = await Promise.all(z.tools.map(k => card(k, true).catch(() => null)));
    if (current !== revision) return;
    main.replaceChildren(...sections);
    accessories.filter(Boolean).forEach(c => tools.append(c));
    main.setAttribute('aria-busy', 'false');
  }

  function prefetch(index) {
    const z = config.zones[index];
    if (!z) return;
    z.sections.forEach(s => s.keys.forEach(k => (groups[k] ? groups[k].options : []).forEach(o => product(o.handle).catch(() => null))));
    z.tools.forEach(k => (groups[k] ? groups[k].options : []).forEach(o => product(o.handle).catch(() => null)));
  }

  zoneButtons.forEach((button, i) => {
    button.addEventListener('click', () => show(i, true));
    button.addEventListener('pointerenter', () => prefetch(i), { once: true });
    button.addEventListener('touchstart', () => prefetch(i), { once: true, passive: true });
  });

  const catalog = document.getElementById('kc-original-catalog');
  const toggle = root.querySelector('[data-kc-all]');
  if (catalog && toggle) {
    toggle.addEventListener('click', () => {
      const open = catalog.classList.toggle('kc-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (open) catalog.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  }
  show(0, false);
})();
